export class ClassificationDoesNotExists extends Error { }
export class FeatureDoesNotExists extends Error { }
export class NoActiveClassification extends Error { }
export class ProductDoesNotExists extends Error { }
export class TaggedFeatureError extends Error { }